import { types } from 'actions/rent_list_actions'
import { createReducer } from '@reduxjs/toolkit'

const initialState = {
  elementGroups: [],
  groupedAvailableElements: {},
  rentedItems: {},
  rentListId: null,
  rentElementRequestInProgress: false,
  errors: []
}

export default createReducer(initialState, (builder) => {
  builder
    .addCase(types.LOAD_DATA, (state, action) => {
      state.elementGroups = action.data.elementGroups || []
      state.groupedAvailableElements = action.data.groupedAvailableElements || {}
      state.rentedItems = action.data.rentedItems || {}
      state.rentListId = action.data.rentListId
    })
    .addCase(types.RENT_ELEMENT_REQUEST, (state) => {
      state.rentElementRequestInProgress = true
    })
    .addCase(types.RENT_ELEMENT, (state, action) => {
      const elementId = action.data.element.id.toString()
      if (!state.rentedItems[elementId]) {
        state.rentedItems[elementId] = []
      }
      state.rentedItems[elementId].push(action.data)
      state.rentElementRequestInProgress = false
    })
    .addCase(types.RENT_ELEMENT_FAILURE, (state, action) => {
      state.rentElementRequestInProgress = false
      state.errors.push(action.error.response.data.error)
    })
    .addCase(types.UNRENT_ITEM_REQUEST, (state) => {
      state.rentElementRequestInProgress = true
    })
    .addCase(types.UNRENT_ITEM, (state, action) => {
      const elementId = action.data.element.id.toString()
      const rentListId = state.rentListId
      if (state.rentedItems[elementId]) {
        state.rentedItems[elementId] = state.rentedItems[elementId]
          .filter(item => item.rentList?.id !== rentListId)
      }
      state.rentElementRequestInProgress = false
    })
    .addCase(types.UNRENT_ITEM_FAILURE, (state, action) => {
      state.rentElementRequestInProgress = false
      state.errors.push(action.error.response.data.error)
    })
    .addCase(types.CLEAR_ERRORS, (state) => {
      state.errors = []
    })
})
